var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.2324C16.5228 21.2324 21 16.7553 21 11.2324C21 5.70957 16.5228 1.23242 11 1.23242C5.47715 1.23242 1 5.70957 1 11.2324C1 16.7553 5.47715 21.2324 11 21.2324Z",
    stroke: "url(#paint0_linear_3323_90763)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 8.23299C8.32885 7.56466 8.7929 7.0011 9.4037 6.64212C10.0145 6.28315 10.7326 6.15193 11.4309 6.2717C12.1292 6.39148 12.7626 6.75452 13.2188 7.29652C13.6751 7.83852 13.9248 8.52451 13.9237 9.23299C13.9237 11.233 10.9237 12.233 10.9237 12.233",
    stroke: "url(#paint1_linear_3323_90763)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.2324H11.01",
    stroke: "url(#paint2_linear_3323_90763)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3323_90763",
    x1: 8.11946,
    y1: 13.4037,
    x2: 14.4628,
    y2: 8.62995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1473,
    stopColor: "#EE4F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#F06022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#F37820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8675,
    stopColor: "#F7951D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA61A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3323_90763",
    x1: 10.1691,
    y1: 9.88262,
    x2: 12.0573,
    y2: 8.50294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1473,
    stopColor: "#EE4F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#F06022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#F37820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8675,
    stopColor: "#F7951D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA61A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3323_90763",
    x1: 11.0036,
    y1: 16.841,
    x2: 11.0085,
    y2: 16.8409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1473,
    stopColor: "#EE4F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#F06022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#F37820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8675,
    stopColor: "#F7951D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA61A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.9be70f193cfb8df5946a10d6a7788537.svg";
export { ForwardRef as ReactComponent };